<div class="td col-name large text-ellipsis">
  <div class="layout-row layout-align-start-center margin-right-5">
    @if (canUpdate) {
      <app-threepl-service-actions [service]="service()"
                                   (moveToInternal)="moveToInternal.emit($event)"
                                   (addNote)="addNote.emit($event)"
                                   (cancel)="cancel.emit($event)">
      </app-threepl-service-actions>
      <bz-checkbox class="margin-left-10 select-checkbox" size="sm"
                   appBringozIdGenerator="threepl-services-row-select-checkbox"
                   [ariaLabel]="'Select Service' | translate"
                   [checked]="isSelected()"
                   (click)="onCheckboxClick($event)">
      </bz-checkbox>
    }
  </div>

  <div class="layout-column">
    <div class="layout-row layout-align-start-center">
      <bz-tag [tone]="service().status | threeplStatusTone" class="margin-right-5">{{ service().status | translate }}</bz-tag>
      <app-threepl-service-link class="margin-right-5" [serviceId]="service().id" [externalId]="service().externalId"></app-threepl-service-link>
    </div>
    <div class="layout-row layout-align-start-center">
      <app-service-type-indication class="margin-right-5" [serviceType]="service().serviceType" [isShort]="true"></app-service-type-indication>
      @if (service().items?.length) {
        <app-threepl-service-packages-indication [packages]="service().items"></app-threepl-service-packages-indication>
      }
      <span container="body" [ngbTooltip]="'Extra Info' | translate">
        <bz-button variant="tertiary" size="fit" class="margin-left-5"
                   appBringozIdGenerator="moreInformationBtn"
                   [ariaLabel]="'Extra Info' | translate"
                   (clicked)="onOpenAttemptInfoDialog($event)">
          <bz-icon class="extra-info-icon" [icon]="infoIcon"></bz-icon>
        </bz-button>
      </span>
    </div>
  </div>
</div>

@if (columns()?.orderId) {
  <div class="td col-order-id small">
    <app-threepl-service-chips [items]="derived().omsOrderIds"></app-threepl-service-chips>
  </div>
}

@if (columns()?.operationalUnits) {
  <div class="td col-branches small">
    <branches-indicator [branches]="derived().branchReferences"></branches-indicator>
  </div>
}

@if (columns()?.account) {
  <div class="td col-account large">
    @if (service().fulfillmentStepInfoList?.[0]?.accountReference; as account) {
      <app-demand-account-link class="flex" [account]="account" [isAllowCopyButton]="true"></app-demand-account-link>
    }
  </div>
}

@if (columns()?.supplierAccount) {
  <div class="td col-carrier large">
    <app-supply-account-link class="text-ellipsis-multi-lines-2" [account]="service().supplierAccountReference"></app-supply-account-link>
  </div>
}

@if (columns()?.location) {
  <div class="td col-location large">
    <div class="layout-column min-width-0">
      @if (service().pickup) {
        <div class="layout-row layout-align-start-center">
          <span class="origin margin-right-5">P</span>
          <span class="text-ellipsis">{{ service().pickup.address | bringozAddress }}</span>
        </div>
      }
      @if (service().destination) {
        <div class="layout-row layout-align-start-center">
          <span class="destination margin-right-5">D</span>
          <span class="text-ellipsis">{{ service().destination.address | bringozAddress }}</span>
        </div>
      }
    </div>
  </div>
}

@if (columns()?.taskApprovalStatus) {
  <div class="td col-approval-status small">
    <div class="layout-column min-width-0">
      <span class="br-body-2">{{ service().threePlExtraData?.pickupApprovalInfo?.approvalVehicleLicensePlanteNumber }}</span>
      @if (service().threePlExtraData?.pickupApprovalInfo?.contractorApprovalStatus; as status) {
        <div class="layout-row layout-align-start-center">
          <span class="origin margin-right-5">P</span>
          <span class="text-ellipsis">{{ 'TASK_APPROVAL_STATUS.' + status }}</span>
        </div>
      }
      @if (service().threePlExtraData?.destinationApprovalInfo?.contractorApprovalStatus; as status) {
        <div class="layout-row layout-align-start-center">
          <span class="destination margin-right-5">D</span>
          <span class="text-ellipsis">{{ 'TASK_APPROVAL_STATUS.' + status }}</span>
        </div>
      }
    </div>
  </div>
}

@if (columns()?.contact) {
  <div class="td col-contact small">
    <div class="layout-column min-width-0">
      @if (pickupContact(); as contact) {
        <div class="layout-row layout-align-start-center">
          <span class="origin margin-right-5">P</span>
          <div container="body" class="font-weight-400 text-ellipsis" data-sl="mask" [ngbTooltip]="contact.tooltip">
            @for (part of contact.parts; track $index; let last = $last) {
              <span class="br-body-2">{{ part }}</span>
              @if (!last) {
                <span class="br-body-2 contact-separator">/</span>
              }
            }
          </div>
        </div>
      }
      @if (destinationContact(); as contact) {
        <div class="layout-row layout-align-start-center">
          <span class="destination margin-right-5">D</span>
          <div container="body" class="font-weight-400 text-ellipsis" data-sl="mask" [ngbTooltip]="contact.tooltip">
            @for (part of contact.parts; track $index; let last = $last) {
              <span class="br-body-2">{{ part }}</span>
              @if (!last) {
                <span class="br-body-2 contact-separator">/</span>
              }
            }
          </div>
        </div>
      }
    </div>
  </div>
}

@if (columns()?.programType) {
  <div class="td col-program-type small">
    <app-threepl-service-chips [items]="derived().programNames"></app-threepl-service-chips>
  </div>
}

@if (columns()?.eta) {
  <div class="td col-eta small">
    @if (service().eta) {
      <span class="br-body-1">{{ service() | bringozTime: 'eta' }}</span>
    }
  </div>
}

@if (columns()?.timeToDeliver) {
  <div class="td col-time-to-deliver small">
    @if (service().etd) {
      <span class="br-body-1">{{ service() | bringozTime: 'etd' }}</span>
    }
  </div>
}

@if (columns()?.distance) {
  <div class="td col-distance small">
    <span>{{ service().distance | bringozDistance: '---' }}</span>
  </div>
}

@if (columns()?.serviceAreas) {
  <div class="td col-service-areas small">
    <div class="layout-column min-width-0">
      @if (service().pickup?.address?.areaIdList?.length) {
        <div class="layout-row layout-align-start-center">
          <span class="origin margin-right-5">P</span>
          <app-threepl-service-chips [items]="areaNames().pickup"></app-threepl-service-chips>
        </div>
      }
      @if (service().destination?.address?.areaIdList?.length) {
        <div class="layout-row layout-align-start-center">
          <span class="destination margin-right-5">D</span>
          <app-threepl-service-chips [items]="areaNames().destination"></app-threepl-service-chips>
        </div>
      }
    </div>
  </div>
}

@if (columns()?.timeWindow) {
  <div class="td col-time-window large">
    <div class="layout-column min-width-0">
      @if (service().pickup) {
        <div class="layout-row layout-align-start-center">
          <span class="origin margin-right-5">P</span>
          <span class="text-ellipsis">{{ service().pickup | timeWindow }}</span>
        </div>
      }
      @if (service().destination) {
        <div class="layout-row layout-align-start-center">
          <span class="destination margin-right-5">D</span>
          <span class="text-ellipsis">{{ service().destination | timeWindow }}</span>
        </div>
      }
    </div>
  </div>
}

@if (columns()?.price) {
  <div class="td col-price small">
    <span>{{ service().price | bringozPrice: undefined : service().threePlExtraData?.currency }}</span>
  </div>
}

@if (columns()?.notes) {
  <div class="td col-notes large">
    @if (service().notes?.length) {
      <div class="layout-column notes-container">
        @for (note of service().notes; track $index) {
          <span>{{ note.text }}</span>
        }
      </div>
    }
  </div>
}

@if (columns()?.created) {
  <div class="td col-created small">
    <span class="br-body-2">{{ service().createdAt | bringozTimeAgo }}</span>
  </div>
}

@for (metaData of dynamicColumns(); track metaData.key) {
  <div class="td small text-ellipsis" [class]="metaData.cls">
    <span class="br-body-2 text-ellipsis">{{ service().metadata | bringozMetaDataDisplay: metaData }}</span>
  </div>
}
